import axios from "axios";
import { returnURL, returnJson } from "../ApiSettings/returnURL";
import moment from "moment";
const CancelCallUrl = "api/Calls/Cancel";
const ActiveCallsUrl = "api/Button/List";

// Get Appointments Calls
export async function getReservationHistoryApi(url, token, phone) {
  let url_request = url;
  url_request = returnURL(url_request) + ActiveCallsUrl;

  let start = moment().subtract(1, "M").unix();
  let end = moment().add(2, "M").unix();

  let params = {
    returnReservations: true,
    maxResults: 50,
    startTimeStampOfCalls: start,
    endTimeStampOfCalls: end,
    needAllCalls: true,
    filterOnCheckedStatus: 1,
    includeRouteInfo: true,
  };

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

// Cancel Appointments
export async function cancelAppointmentApi(url, appID, token) {
  let url_request = url + CancelCallUrl;
  url_request = returnURL(url_request);

  let params = {
    //callId: appID,
    appId: appID,
    //comments: "string",
    //taxiNo: "string",
    //driverID: 0,
  };

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}
